import { subtitleWords } from './subtitleText.js';
export function xrSubtitleLayout(text, columns = 58, lines = 3) {
    let column = 0;
    let row = 0;
    return subtitleWords(text).flatMap(word => {
        if (typeof word === 'string') {
            if (word.includes('\n')) {
                row++;
                column = 0;
            }
            else
                column += word.length;
            return [];
        }
        if (column && column + word.text.length > columns) {
            row++;
            column = 0;
        }
        const placed = { ...word, column, row: row % lines, page: Math.floor(row / lines) };
        column += word.text.length;
        return [placed];
    });
}
export function xrTextPages(text, columns = 58, linesPerPage = 13) {
    const lines = [];
    for (const paragraph of text.split('\n')) {
        let line = '';
        for (const word of paragraph.split(/\s+/).filter(Boolean)) {
            if (line && line.length + word.length + 1 > columns) {
                lines.push(line);
                line = '';
            }
            // Split unbroken identifiers as well as ordinary prose.
            let remaining = word;
            while (remaining.length > columns) {
                if (line) {
                    lines.push(line);
                    line = '';
                }
                lines.push(remaining.slice(0, columns));
                remaining = remaining.slice(columns);
            }
            line = line ? `${line} ${remaining}` : remaining;
        }
        lines.push(line);
    }
    const pages = [];
    for (let index = 0; index < lines.length; index += linesPerPage)
        pages.push(lines.slice(index, index + linesPerPage).join('\n'));
    return pages;
}
export function xrRuleText(panel) {
    return [panel.heading, ...panel.groups.flatMap(group => [group.heading, ...group.items.map(item => `- ${item}`)]),
        ...(panel.note ? [panel.note] : [])].join('\n');
}
